import { clsx } from 'clsx'
import { forwardRef, type ReactNode, type Ref } from 'react'

interface MenuItemProps {
  label: string
  leadingIcon?: ReactNode
  trailingIcon?: ReactNode
  onClick?: () => void
  href?: string
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  danger?: boolean
  hoverActive?: boolean
  borderBottom?: boolean
  'data-testid'?: string
}

export const MenuItem = forwardRef<HTMLButtonElement | HTMLAnchorElement, MenuItemProps>(function MenuItem(
  {
    label,
    leadingIcon,
    trailingIcon,
    onClick,
    href,
    onMouseEnter,
    onMouseLeave,
    danger,
    hoverActive,
    borderBottom,
    'data-testid': dataTestId,
  },
  ref,
) {
  const className = clsx('sidebar-profile-menu__item', {
    'sidebar-profile-menu__item--danger': danger,
    'sidebar-profile-menu__item--active': hoverActive,
    'sidebar-profile-menu__item--border-bottom': borderBottom,
  })

  const content = (
    <>
      {leadingIcon ? <span className="sidebar-profile-menu__item-leading">{leadingIcon}</span> : null}
      <span className="sidebar-profile-menu__item-label">{label}</span>
      {trailingIcon ? <span className="sidebar-profile-menu__item-trailing">{trailingIcon}</span> : null}
    </>
  )

  if (href) {
    return (
      <a
        ref={ref as Ref<HTMLAnchorElement>}
        href={href}
        target="_blank"
        rel="noreferrer"
        role="menuitem"
        className={className}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        data-testid={dataTestId}
      >
        {content}
      </a>
    )
  }

  return (
    <button
      ref={ref as Ref<HTMLButtonElement>}
      type="button"
      role="menuitem"
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      {content}
    </button>
  )
})
